import I18n from 'I18n';
import getLangLocale from 'I18n/utils/getLangLocale';
import { useQuery } from 'data-fetching-client';
import { GET_BUSINESS_OBJECTIVES } from 'pricing-pages-api/business-objectives/queries';
const usePriorityFeaturesForApiNames = ({
  highlightedProducts,
  highlightedFeatureType
}) => {
  // @ts-expect-error dependency missing types
  const langLocale = I18n.loaded && I18n.locale ? getLangLocale() : 'en-us';
  const {
    data,
    loading
  } = useQuery(GET_BUSINESS_OBJECTIVES, {
    variables: {
      highlightedProducts,
      highlightedFeatureType,
      langLocale
    },
    skip: !highlightedProducts.length
  });
  return {
    businessObjectives: (data === null || data === void 0 ? void 0 : data.businessObjectives) || [],
    loading
  };
};
export const usePriorityFeaturesForApiName = ({
  apiName
}) => {
  var _BO$features;
  const {
    businessObjectives,
    loading
  } = usePriorityFeaturesForApiNames({
    highlightedProducts: [apiName]
  });
  const BO = businessObjectives.find(bo => bo.productApiName === apiName);
  const features = (BO === null || BO === void 0 || (_BO$features = BO.features) === null || _BO$features === void 0 ? void 0 : _BO$features.filter(feature => !feature.hideFromLang)) || [];
  return {
    loading,
    features
  };
};
export const useCategorizedPriorityFeatures = ({
  apiName
}) => {
  const {
    loading,
    features
  } = usePriorityFeaturesForApiName({
    apiName
  });
  const brandingAndLimitFeatures = features.filter(feature => feature.featureCategory === 'LIMIT_INCREASE' || feature.featureCategory === 'REMOVE_BRANDING');
  const uncategorizedFeatures = features.filter(feature => feature.featureCategory === 'UNCATEGORIZED');
  return {
    loading,
    brandingAndLimitFeatures,
    uncategorizedFeatures
  };
};
export const usePriorityFeaturesFilteredByFreeUserAccessLevel = ({
  apiName,
  requiresPaidSeat,
  featureCountLimit
}) => {
  const {
    businessObjectives,
    loading
  } = usePriorityFeaturesForApiNames({
    highlightedProducts: [apiName],
    highlightedFeatureType: 'SEATS'
  });
  const BO = businessObjectives.find(bo => bo.productApiName === apiName);
  const features = (BO === null || BO === void 0 ? void 0 : BO.features) || [];

  //  Filter based on requiresPaidSeat input
  const filteredAndSortedFeatures = features.filter(feature => {
    const requiresSeat = feature.freeUserAccessLevel === 'NO_ACCESS' || feature.freeUserAccessLevel === 'LIMITED_ACCESS';
    return requiresPaidSeat === requiresSeat;
  }).sort((a, b) => a.featureId - b.featureId);
  const filteredFeatures = featureCountLimit ? filteredAndSortedFeatures.slice(0, featureCountLimit) : filteredAndSortedFeatures;
  return {
    loading,
    features: filteredFeatures
  };
};